"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _placeholder = _interopRequireDefault(require("../../assets/images/placeholder.png"));
var _Avatar = require("./Avatar.styles");
var _theme = require("../utils/theme");
var _S3PrivateImage = _interopRequireDefault(require("../S3PrivateImage/S3PrivateImage"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Text = _interopRequireDefault(require("../Text/Text"));
var _excluded = ["theme", "elevation", "size", "s3Key", "s3Bucket", "s3ZoomKey", "s3ZoomBucket", "preview", "children", "shouldZoom", "cleanLoading", "initials", "borderRadius"];
var Avatar = function Avatar(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 'none' : _ref$elevation,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '80' : _ref$size,
    s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket,
    s3ZoomKey = _ref.s3ZoomKey,
    s3ZoomBucket = _ref.s3ZoomBucket,
    preview = _ref.preview,
    children = _ref.children,
    _ref$shouldZoom = _ref.shouldZoom,
    shouldZoom = _ref$shouldZoom === void 0 ? false : _ref$shouldZoom,
    _ref$cleanLoading = _ref.cleanLoading,
    cleanLoading = _ref$cleanLoading === void 0 ? false : _ref$cleanLoading,
    initials = _ref.initials,
    borderRadius = _ref.borderRadius,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var defaultContent = function defaultContent() {
    return initials ? /*#__PURE__*/_react["default"].createElement(_Avatar.Initials, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      weight: "bold",
      type: "subtitle",
      color: theme.color.primary["default"]
    }, initials)) : null;
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Avatar.AvatarContainer, (0, _extends2["default"])({
    theme: theme,
    elevation: elevation,
    size: size,
    borderRadius: borderRadius
  }, props), preview ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: "photoAvatar",
    shouldZoom: shouldZoom,
    src: preview,
    theme: theme
  }) : /*#__PURE__*/_react["default"].createElement(_S3PrivateImage["default"], {
    cleanLoading: cleanLoading,
    shouldZoom: shouldZoom,
    className: "photoAvatar",
    placeholder: _placeholder["default"],
    s3Key: s3Key,
    s3Bucket: s3Bucket,
    s3ZoomKey: s3ZoomKey,
    s3ZoomBucket: s3ZoomBucket,
    defaultContent: defaultContent()
  })));
};
var _default = exports["default"] = Avatar;